<template>
  <div class="flex items-center justify-center">
    <div
      :class="`text-[13px] py-[4px] px-[16px] rounded-full ${mapStorageRequestStatus.color} ${mapStorageRequestStatus.bgColor}`"
    >
      {{ mapStorageRequestStatus.label }}
    </div>
  </div>
</template>

<script>
import { storageRequestStatus } from './config'

export default {
  name: 'StorageRequestStatusCell',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    mapStorageRequestStatus() {
      if (!this.status) {
        return {
          label: 'Proses Pengajuan',
          color: 'text-[#FBA63C]',
          bgColor: 'bg-[#FCEBBE]',
        }
      }

      const statusKey = this.status.toLowerCase()
      const config = storageRequestStatus[statusKey]

      if (!config) {
        return {
          label: 'Proses Pengajuan',
          color: 'text-[#FBA63C]',
          bgColor: 'bg-[#FCEBBE]',
        }
      }

      return config
    },
  },
}
</script>
